import { dew as _constantsDew } from "../constants";
import { dew as _resultsDew } from "../../../results";
import { dew as _AbstractParserWithWordBoundaryDew } from "../../../common/parsers/AbstractParserWithWordBoundary";
import { dew as _timeunitsDew } from "../../../utils/timeunits";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const constants_1 = _constantsDew();
  const results_1 = _resultsDew();
  const AbstractParserWithWordBoundary_1 = _AbstractParserWithWordBoundaryDew();
  const timeunits_1 = _timeunitsDew();
  const PATTERN = new RegExp(`(эти|последние|прошлые|следующие|после|спустя|через|\\+|-)\\s*(${constants_1.TIME_UNITS_PATTERN})${constants_1.REGEX_PARTS.rightBoundary}`, constants_1.REGEX_PARTS.flags);
  class RUTimeUnitCasualRelativeFormatParser extends AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking {
    patternLeftBoundary() {
      return constants_1.REGEX_PARTS.leftBoundary;
    }
    innerPattern() {
      return PATTERN;
    }
    innerExtract(context, match) {
      const prefix = match[1].toLowerCase();
      let timeUnits = constants_1.parseTimeUnits(match[2]);
      switch (prefix) {
        case "\u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0435":
        case "\u043F\u0440\u043E\u0448\u043B\u044B\u0435":
        case "-":
          timeUnits = timeunits_1.reverseTimeUnits(timeUnits);
          break;
      }
      return results_1.ParsingComponents.createRelativeFromReference(context.reference, timeUnits);
    }
  }
  exports.default = RUTimeUnitCasualRelativeFormatParser;
  //# sourceMappingURL=RUTimeUnitCasualRelativeFormatParser.js.map
  return exports;
}